import { render, staticRenderFns } from "./ConfigurationIndex.vue?vue&type=template&id=04c52dbe&scoped=true"
import script from "./ConfigurationIndex.vue?vue&type=script&lang=js"
export * from "./ConfigurationIndex.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/modal.css?vue&type=style&index=0&id=04c52dbe&prod&scoped=true&lang=css&external"
import style1 from "./ConfigurationIndex.vue?vue&type=style&index=1&id=04c52dbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c52dbe",
  null
  
)

export default component.exports